import { SgvJson } from '@eceos/arch';

export class UserConfirmResult {
  constructor(public token = '') {}

  static fromJson(json: any): UserConfirmResult {
    return json ? SgvJson.from.simple(json, UserConfirmResult) : null;
  }
}
